<template>
  <template v-if="Array.isArray(store.state.menu.menuCategories) && store.state.menu.menuCategories.length">
    <div class="text-sm sm:text-base">
      <ul>
        <li v-for="category in store.state.menu.menuCategories" :key="category.id">
          <template v-if="Array.isArray(category.menus) && category.menus.length">
            <div class="py-2 border-gray-200 border-b">
              <div class="flex items-center justify-between px-4 py-2">
                <div class="font-semibold text-sm text-gray-500 whitespace-nowrap">{{ category.name }}</div>
              </div>
              <layouts-auth-sidebar-content-menu :menus="category.menus" />
            </div>
          </template>
        </li>
      </ul>
    </div>
  </template>
  <ul>
    <div class="py-2 border-gray-200 border-b cursor-pointer hover:bg-gray-200" :class="['/recommend' === currentUrl ? 'bg-blue-200': '']" @click="routeRecommend">
      <div class="flex items-center justify-between px-4 py-2">
        <div class="font-semibold text-sm text-gray-500 whitespace-nowrap">{{ t('recommend.title') }}</div>
      </div>
    </div>
  </ul>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import { useStore } from '@/store/index'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'

import LayoutsAuthSidebarContentMenu from '@/components/LayoutsAuthSidebarContentMenu.vue'

export default defineComponent({
  components: { LayoutsAuthSidebarContentMenu },
  setup() {
    const menuCategory = ref([1, 2, 3])
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const { t } = useI18n()

    const routeRecommend = () => {
      store.dispatch('menu/switchSidebarOpen')
      router.push({ name: 'RecommendCourseList'})
    }

    const currentUrl = computed(() => {
      return `${route.path}${window.location.search}`
    })

    return {
      t,
      menuCategory,
      store,
      routeRecommend,
      currentUrl
    }
  },
})
</script>
